__turbopack_context__.v({
  "link": "NewsSection-module-scss-module__KWpJKG__link",
  "newsCardsBlock": "NewsSection-module-scss-module__KWpJKG__newsCardsBlock",
  "newsSection": "NewsSection-module-scss-module__KWpJKG__newsSection",
  "title": "NewsSection-module-scss-module__KWpJKG__title",
});
